export default "/images/sonderjysk.avif?5a69f9cceede23fab338b7f78cebce7f";